import { createContext, ReactNode, useContext, useState } from "react"
import { Toast, ToastContainer } from "react-bootstrap"

const ToastContext = createContext<{
  add: (toast: { type: "danger" | "warning" | "success"; title: string; message: string }) => void
}>({
  add: () => {
  },
})
ToastContext.displayName = "ToastContext"

export const useToast = () => {
  return useContext(ToastContext)
}

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toastsState, setToastsState] = useState<{ key: string; type: "danger" | "warning" | "success"; title: string; message: string; hide?: boolean }[]>([])

  return (
    <ToastContext.Provider
      value={{
        add: ({ type, message, title }) => {
          setToastsState((toastState) => [...toastState, { key: crypto.randomUUID(), type, title, message }])
        },
      }}
    >
      {children}
      {
        <ToastContainer position="bottom-end" className="position-fixed p-3 pb-5" style={{ zIndex: 99 }}>
          {toastsState.map((toast) => (
            <Toast
              key={toast.key}
              show={!toast.hide}
              autohide
              bg={toast.type}
              onClose={() => {
                setToastsState((toastState) => toastState.map((t) => (t.key === toast.key ? { ...t, hide: true } : t)))
              }}
            >
              <Toast.Header>
                <strong className="me-auto">{toast.title}</strong>
              </Toast.Header>
              <Toast.Body className={toast.type === "danger" ? "text-white" : undefined}>{toast.message}</Toast.Body>
            </Toast>
          ))}
        </ToastContainer>
      }
    </ToastContext.Provider>
  )
}
